/* eslint-disable  */
//@ts-nocheck

import { LiveChatTab } from '@client/components/livestreaming/LiveChatTab';
import { SetupTab } from '@client/components/livestreaming/SetupTab';
import { LiveClassesTab } from '@client/components/livestreaming/live-classes/LiveClassesTab';
import { Typography } from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';
import auth from '../../../components/auth';

const Container = styled.div`
  ${({ maxw700 }) => (maxw700 ? 'max-width: 700px;' : '')}
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e3e6ed;
`;

const MenuWrap = styled.div`
  display: flex;
  & > * {
    margin: 10px;
  }
  margin: -10px;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const MenuItem = styled.div`
  color: ${({ active }) => (active ? '#ee3b64' : '#151e34')};
  font-weight: 600;
  padding-bottom: 2px;
  border-bottom: 2px solid
    ${({ active }) => (active ? '#ee3b64' : 'transparent')};
  cursor: pointer;
`;

const Menu = ({ openPage, setOpenPage }) => {
  return (
    <MenuWrap>
      <MenuItem
        active={openPage === 'setup'}
        onClick={() => setOpenPage('setup')}
      >
        Setup
      </MenuItem>
      <MenuItem
        active={openPage === 'chat'}
        onClick={() => setOpenPage('chat')}
      >
        Live Chat
      </MenuItem>
      <MenuItem
        active={openPage === 'classes'}
        onClick={() => setOpenPage('classes')}
      >
        Live Classes
      </MenuItem>
    </MenuWrap>
  );
};

type Tabs = 'setup' | 'chat' | 'classes';

export const LiveStream = ({ influencerId }: { influencerId: number }) => {
  const [openPage, setOpenPage] = useState<Tabs>('chat');

  return (
    <div>
      <Menu {...{ openPage, setOpenPage }} />
      <TabComponent influencerId={influencerId} tab={openPage} />
    </div>
  );
};

const TabComponent = ({
  tab,
  influencerId,
}: {
  tab: Tabs;
  influencerId: number;
}) => {
  switch (tab) {
    case 'setup':
      return (
        <Container maxw700>
          <SetupTab influencerId={influencerId} />
        </Container>
      );
    case 'chat':
      return (
        <Container maxw700>
          <LiveChatTab influencerId={influencerId} />
        </Container>
      );
    case 'classes':
      return (
        <Container>
          <LiveClassesTab influencerId={influencerId} />
        </Container>
      );
  }
};
